import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { JoinPlatformButton } from './JoinPlatformButton';
import { Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-209" data-mp="9ktc3i8tpsv4">
      {/* Full-width background image */}
      <div className="absolute inset-0" data-id="element-210" data-mp="4mruz2uyk3ma">
        <img src="https://cdn.magicpatterns.com/uploads/dZ8Roj232HgCNMNue9AsoW/pexels-anntarazevich-4926666.jpg" alt="Women supporting each other" className="w-full h-full object-cover object-[center_30%] scale-110" data-id="element-211" data-mp="4jm69oq8r3r3" />
        {/* Subtle overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/40 via-charcoal/30 to-charcoal/50" data-id="element-212" data-mp="sd4cn5g09eq2"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-transparent" data-id="element-213" data-mp="3d1ii934hv0k9"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10 text-center text-white" data-id="element-214" data-mp="381xm10gpl6b8">
        <FadeIn delay={100} data-id="element-215" data-mp="3j8iw0w4jiat4">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-md mb-8" data-id="element-216" data-mp="3j8977bv8e9p0">
            <Sparkles className="w-4 h-4 text-purple-300" data-id="element-217" data-mp="3o5j41cky9nmv" />
            <span className="text-sm font-medium tracking-wide uppercase text-white/90" data-id="element-218" data-mp="399bahlnnj9ux">
              A New Standard in Women's Wellness
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={300} data-id="element-219" data-mp="30hrfnam4xk58">
          <h1 className="text-5xl md:text-6xl lg:text-8xl font-serif text-white leading-[1.1] mb-8 tracking-tight max-w-5xl mx-auto drop-shadow-2xl" data-id="element-220" data-mp="30ggezjnzksic">
            The Future of Women's Wellness,{' '}
            <span className="italic text-white/95" data-id="element-221" data-mp="2qleqmq1jbugt">Curated Intelligently</span>
          </h1>
        </FadeIn>

        <FadeIn delay={500} data-id="element-222" data-mp="2vj7sj6vt22ba">
          <p className="text-lg md:text-2xl text-white/90 max-w-3xl mx-auto mb-12 font-light leading-relaxed drop-shadow-lg" data-id="element-223" data-mp="2hj5czrayzkz7">
            A private digital ecosystem connecting women to trusted
            practitioners, personalized care, and intelligent wellness pathways
            — all in one seamless platform.
          </p>
        </FadeIn>

        <FadeIn delay={700} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-224" data-mp="naji3pzjuhg2">
          <a href="/practitioners/join" className="w-full sm:w-auto inline-flex items-center justify-center whitespace-nowrap rounded-full px-10 py-4 text-lg font-sans font-black bg-purple-200 text-gray-700 hover:bg-purple-300 shadow-xl transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-charcoal" data-id="element-225" data-mp="ia5f4mct1xow">
            Join as a Practitioner
          </a>
          <JoinPlatformButton label="Find the Right Care" variant="outline" className="w-full sm:w-auto whitespace-nowrap border-2 border-white text-white hover:bg-white/20 backdrop-blur-sm bg-white/10 shadow-xl" data-id="element-226" data-mp="x37falufynfb" />
        </FadeIn>
      </div>
    </section>;
}